export type ScreenerColumnFormat =
  | "currency"
  | "compact-currency"
  | "percent"
  | "number"
  | "integer"
  | "text";
const screenerColumns: Array<[string, string, ScreenerColumnFormat, boolean]> =
  [
    ["currentPrice", "Cotação", "currency", true],
    ["volatilityAnnualized21dPct", "Volatilidade 21d", "percent", true],
    ["currentPvp", "P/VP", "number", true],
    ["pvpDiscountToHistAvgPct", "Desconto P/VP vs média", "percent", true],
    ["dy12mPct", "DY 12m", "percent", true],
    ["dyMesPct", "DY mês", "percent", true],
    ["dyGrowth12mPct", "Cresc. DY 12m", "percent", true],
    ["inadimplenciaPct", "Inadimplência", "percent", true],
    ["vacanciaPct", "Vacância", "percent", true],
    ["cashEquivalentPct", "Caixa equivalente", "percent", true],
    ["cashResultPlPct", "Caixa/resultado", "percent", true],
    ["cashPressureMonths12m", "Pressão de caixa", "number", true],
    ["cashTrendStatus", "Tendência de caixa", "text", false],
    ["concentracaoTijoloPct", "Concentração tijolo", "percent", true],
    ["concentracaoPapelPct", "Concentração papel", "percent", true],
    ["liquidezDiaria30d", "Liquidez diária 30d", "compact-currency", true],
    ["selicSensitivityScore", "Sensibilidade Selic", "number", true],
    ["leverageIndexScore", "Índice de alavancagem", "number", true],
    ["distanceTo12mHighPct", "Distância da máxima 12m", "percent", true],
    ["vpPerShareGrowth12mPct", "Cresc. VP/cota 12m", "percent", true],
    ["patrimonioLiquido", "Patrimônio líquido", "compact-currency", true],
    ["numeroCotistas", "Cotistas", "integer", true],
  ];
export const SCREENER_COLUMNS: Array<{
  key: string;
  label: string;
  format: ScreenerColumnFormat;
  sortable: boolean;
}> = screenerColumns.map(([key, label, format, sortable]) => ({
  key,
  label,
  format: format as ScreenerColumnFormat,
  sortable: sortable as boolean,
}));
export const SCREENER_FIELD_KEYS = SCREENER_COLUMNS.map((c) => c.key);
export const SCREENER_SORTABLE_KEYS = SCREENER_COLUMNS.filter(
  (c) => c.sortable,
).map((c) => c.key);
export const SCREENER_ENUMS = {
  fundTypes: [
    "FII",
    "FIAGRO",
    "FIAGRO-FII",
    "FIAGRO-FIDC",
    "FIDC",
    "FIP",
    "FI-INFRA",
    "ETF",
    "ETF-FII",
    "ETF-RF",
    "ETF-INT-RF",
    "ETF-CRIPTO",
    "SETORIAL",
    "INDEX",
    "TESOURO",
  ],
  classificacao: ["TIJOLO", "PAPEL", "HIBRIDO", "SEM_DADOS"],
  gestao: ["Ativa", "Definida"],
  segmento: [
    "Escritórios",
    "Hospital",
    "Hotel",
    "Logística",
    "Multicategoria",
    "Outros",
    "Residencial",
    "Shoppings",
    "Títulos e Val. Mob.",
    "Varejo",
  ],
  cashTrendStatus: ["POSITIVO", "NEGATIVO_COM_MELHORA", "NEGATIVO_SEM_MELHORA"],
} as const;
export const CLASSIFICACAO_LABELS: Record<string, string> = {
  TIJOLO: "Tijolo",
  PAPEL: "Papel",
  HIBRIDO: "Híbrido",
  SEM_DADOS: "Sem dados",
};
export const CASH_TREND_STATUS_LABELS: Record<string, string> = {
  POSITIVO: "Positivo",
  POSITIVO_COM_MELHORA: "Positivo",
  POSITIVO_SEM_MELHORA: "Positivo",
  NEGATIVO_COM_MELHORA: "Negativo com melhora",
  NEGATIVO_SEM_MELHORA: "Negativo sem melhora",
};
